import React, { useContext, useEffect, useRef, useState } from "react";
import { LAText, LAView, LAWarningPopup } from "../../components";
import { IMAGES, SVG_IMAGES } from "../../assets";
import { useLocation, useNavigate } from "react-router-dom";
import HTMLContent from "../../components/HTMLContent";
import ExplanationComponent from "../../components/ExplanationComponent";
import AnswerMessage from "../../components/AnswerMessage";
import NavBar from "../../components/NavBar";
import { STRING, STRINGS } from "../../constant";
import { AuthContext } from "../../context/AuthProvider";
import { BundleContext } from "../../context/BundleProvider";
import { AppContext } from "../../context/AppProvider";
import { GET_APP_DOMAIN_LIST } from "../../../app_constant";
import { toHHMMSS } from "../../constant/strings";
import { ThemeContext } from "../../context/ThemeProvider";
import BackArrowIcon from "../../components/BackArrowIcon";
import TabFooter from "../../components/TabFooter";
import { MixpanelContext } from "../../context/MixpanelProvider";
import QuestionOptions from "../../components/question/QuestionOptions";
import { createLogger } from "../../utils/logger";
import {
  GET_CUSTOM_TEST_DETAILS,
  GET_PRACTICE_TEST_DETAILS,
  GET_QUESTION_FROM_ID,
  GET_RETAKE_TEST_DETAILS,
} from "../../api/test";
import { APPEND_TEST_HISTORY } from "../../api/practice";
import InfoDialog from "../../components/InfoDialog";
import { getPracticeTestIconBg, getColorRed } from "../../utils/themeUtils";
import { motion, AnimatePresence } from "framer-motion";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { 
  faArrowLeft, 
  faClock, 
  faQuestionCircle, 
  faCheck,
  faCheckDouble,
  faExclamationCircle,
  faTimesCircle
} from '@fortawesome/free-solid-svg-icons';

const Test = (props) => {
  const {
    profile,
    questionsList,
    community,
    setTestHistory,
    addQuestionScore,
    addAllQuestionScore,
    questionScrore,
    loggingEnabled,
  } = useContext(AuthContext);
  
  const logger = createLogger(loggingEnabled, "Test");
  const {
    history,
    initalizePracticeTest,
    onSubmitQuestion,
    onChangeTime,
    resetPracticeTest,
  } = useContext(AppContext);

  const { theme, currentTheme } = useContext(ThemeContext);

  const { selectedCertificate } = useContext(BundleContext);
  const { trackReadinessScore, trackPracticeExit, trackPracticeCompleted } =
    useContext(MixpanelContext);
  const { state } = useLocation();

  const [isLoading, setLoading] = useState(false);
  const [isSavingTest, setIsSavingTest] = useState(false);
  const [quickSetState, setQuickSetState] = useState({
    selectedOpion: null,
  });
  const [currentIndex, setCurrentIndex] = useState(0);
  const [lastIndex, setLastIndex] = useState(0);
  const [selectedIndex, setSelectedIndex] = useState(null);
  const [savedAnswers, setSavedAnswers] = useState([]);
  const [isTimeup, setTimeup] = useState(false);

  const [isTestExitPopup, setTestExitPopup] = useState(false);
  const [isTestEndPopup, setTestEndPopup] = useState(false);
  const [historyTimeup, setHistoryTimeup] = useState(null);
  const [testStarted, setTestStarted] = useState(true);

  const lastReadinessScore = profile?.readiness_scores?.readiness_score;
  const [isSubmitAnswer, setSubmitAnswer] = useState({});
  const questionSet = history?.test_questions_meta_data?.length ?? 0;

  const numberOfQuestion = state?.numberOfQuestion;
  const isShowAnswer =
    state?.isShowAnswer || state?.is_show_answer ? true : false;
  const practiceTest = state ?? null;
  const OPTIONS = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z'];

  const navigate = useNavigate();
  const historyRef = useRef(null);
  historyRef.current = history;

  const timeRef = useRef(null);
  timeRef.current = history?.remaining_time;

  const lastIndexRef = useRef(null);
  lastIndexRef.current = lastIndex;

  // Card animations
  const cardVariants = {
    hover: { 
      scale: 1.01,
      boxShadow: "0px 4px 10px rgba(0,0,0,0.05)",
      transition: { type: "spring", stiffness: 400, damping: 15 }
    }
  };

  // Button animations
  const buttonVariants = {
    hover: { 
      scale: 1.05,
      boxShadow: "0px 5px 15px rgba(0,0,0,0.1)",
      transition: { type: "spring", stiffness: 400, damping: 10 }
    },
    tap: { scale: 0.95 }
  };

  // Helper function to get icon background color
  const getIconBg = () => {
    return getPracticeTestIconBg(theme, currentTheme);
  };
  // Helper function to get card background
  const getCardBackground = (iconBg) => {
    const baseColor = currentTheme === 'light' ? theme?.homeCard?.start_light : theme?.homeCard?.start_dark;
    const darkerShade = currentTheme === 'light' ? theme?.homeCard?.end_light : theme?.homeCard?.end_dark;
    return {
      background: `linear-gradient(to right, ${baseColor}, ${darkerShade})`,
      // borderLeft: `4px solid ${iconBg || getPracticeTestIconBg(theme, currentTheme)}`
    };
  };
  
  // Helper function for text color
  const getTextColor = () => {
    return currentTheme === 'light' 
      ? theme?.text?.light
      : theme?.text?.dark;
  };
  
  const getNavBackground = () => {
    return currentTheme === 'light' ? theme?.homeCard?.end_light : theme?.homeCard?.end_dark
  };

  async function onSaveTestHistory(isTimeup) {
    // Prevent multiple simultaneous saves
    if (isSavingTest) {
      logger.log('Test save already in progress, skipping...');
      return;
    }
    
    setIsSavingTest(true);
    
    try {
      let historyData = { ...historyRef.current };
      logger.log("onSaveTestHistory called with isTimeup:", isTimeup);
      logger.log("historyData", historyData);
      logger.log("practiceTest:", practiceTest);

      if (practiceTest?.is_custom_test && practiceTest?.total_time > 0) {
        const totalItems = historyData?.test_questions_meta_data ?? [];
        // Add null check for lastIndexRef.current
        const lastIndexValue = lastIndexRef.current ?? 0;
        logger.log("lastIndexValue:", lastIndexValue);
        const attemptQuestions = totalItems.splice(0, lastIndexValue + 1);
        historyData.test_questions_meta_data = attemptQuestions;
        logger.log("attemptQuestions", attemptQuestions);

        const correct =
          attemptQuestions?.filter((item) => item.response == STRING.correct_tag)
            ?.length ?? 0;
        const incorrect =
          attemptQuestions?.filter(
            (item) => item.response == STRING.incorrect_tag
          )?.length ?? 0;
        const unanswered =
          attemptQuestions?.filter(
            (item) => item.response == STRING.unanswered_tag
          )?.length ?? 0;

        historyData.correct = correct;
        historyData.incorrect = incorrect;
        historyData.unanswered = unanswered;
        historyData.total = attemptQuestions.length;
        historyData.score = parseInt((correct * 100) / attemptQuestions.length);
        
        logger.log("Calculated scores - correct:", correct, "incorrect:", incorrect, "unanswered:", unanswered, "score:", historyData.score);
      }
      
      // Use the new APPEND_TEST_HISTORY API instead of setTestHistory
      logger.log("About to call APPEND_TEST_HISTORY with:", historyData);
      const result = await APPEND_TEST_HISTORY(historyData);
      // Always update local state regardless of API result
//setTestHistory(historyData);

if (result.status) {
  logger.log("Test history saved successfully to database");
} else {
  logger.error("Failed to save test history:", result.error);
}
      
      /* if (result.status) {
        logger.log("Test history saved successfully to database");
        // Update local state with the new history from database
        setTestHistory({ type: 'REFRESH_FROM_DATABASE', payload: result.updatedHistory });
      } else {
        logger.error("Failed to save test history:", result.error);
        // Fallback to old method if new API fails
        setTestHistory(historyData);
      } */
      
      setHistoryTimeup(historyData);

      if (!isShowAnswer) {
        var list = [];
        const question_array = historyData?.test_questions_meta_data ?? [];
        question_array.forEach((element) => {
          list.push({
            question_id: element?.question_id,
            topic_id: element?.topic_id,
            correct: element?.response == STRING.correct_tag,
            selected: element?.response,
          });
        });
        addAllQuestionScore(list);
      }

      const total = historyData?.test_questions_meta_data?.length ?? 0;
      const unanswered =
        historyData?.test_questions_meta_data?.filter(
          (item) => item.response == STRING.unanswered_tag
        )?.length ?? 0;
      const answered = total - unanswered;

      if (isTimeup) {
        trackPracticeCompleted(
          practiceTest?.test_name ?? "",
          total,
          answered,
          profile?.readiness_scores?.readiness_score ?? 0
        );
        setTimeup(true);
      } else {
        trackPracticeCompleted(
          practiceTest?.test_name ?? "",
          total,
          answered,
          profile?.readiness_scores?.readiness_score ?? 0
        );

        navigate("/testReview", { state: { historyData, canGoBackKey: false, lastReadinessScore } });

        resetPracticeTest();
      }
    } catch (error) {
      logger.error("Error saving test history:", error);
    } finally {
      setIsSavingTest(false);
    }
  }

  const backAction = () => {
    onBack();
    return true;
  };

  function onBack() {
    setTestExitPopup(true);
  }

  function onExit() {
    const total = history?.test_questions_meta_data?.length ?? 0;
    const unanswered =
      history?.test_questions_meta_data?.filter(
        (item) => item.response == STRING.unanswered_tag
      )?.length ?? 0;
    const answered = total - unanswered;

    trackPracticeExit(practiceTest?.test_name ?? "", total, answered);

    onUpdateScore();
    resetPracticeTest();

    if (practiceTest?.is_retake_test) {
      navigate("/home", { state: { isShowReview: true } });
    } else {
      navigate(-1);
    }
  }

  function onUpdateScore() {
    logger.log("onUpdateScore" + selectedIndex?.selected);
    if (
      selectedIndex &&
      selectedIndex.selected != "X" &&
      isShowAnswer &&
      selectedIndex.is_from_older == false
    ) {
      addQuestionScore(
        currentItem?.question.id,
        currentItem?.question.topic_id,
        currentItem?.question.correct_answer == selectedIndex.selected
      );
      trackReadinessScore(profile?.readiness_scores?.readiness_score ?? 0);
    }
  }

  function getCurrentQuestion() {
    if (
      history?.test_questions_meta_data?.length > 0 ||
      !isNaN(currentIndex) ||
      history?.test_questions_meta_data?.length > currentIndex
    ) {
      const id = history?.test_questions_meta_data[currentIndex]?.question_id;
      return GET_QUESTION_FROM_ID(questionsList, id);
    } else {
      return null;
    }
  }

  function getTopicId() {
    const APP_DOMAIN_LIST = GET_APP_DOMAIN_LIST(selectedCertificate);
    const array = APP_DOMAIN_LIST.find(
      (item) => item.id == currentItem?.question?.topic_id
    );
    return array?.domain_name ?? "";
  }

  function onPrevious() {
    onUpdateScore();
    setSelectedIndex(null);

    setCurrentIndex((state) => {
      return state == 0 ? 0 : state - 1;
    });
  }

  function onNext() {
    onUpdateScore();
    setSelectedIndex(null);

    if (currentIndex + 1 >= lastIndexRef.current) {
      setLastIndex(currentIndex + 1);
    }

    setCurrentIndex((state) => {
      return state == history?.test_questions_meta_data.length - 1
        ? 0
        : state + 1;
    });
  }

  function onEndTest() {
    onUpdateScore();
    setLoading(true);
    setTimeout(() => {
      setLoading(false);
      setTimeout(() => {
        setTestEndPopup(true);
      }, 500);
    }, 1000);
  }

  const currentItem = getCurrentQuestion();
  const time = toHHMMSS(history.remaining_time);
  const topic = getTopicId();

  useEffect(() => {
    if (history?.test_questions_meta_data?.length > 0) {
      setSelectedIndex({
        selected:
          history?.test_questions_meta_data[currentIndex]?.selected_choice,
        is_from_older: true,
      });
    }
  }, [currentIndex]);

  useEffect(() => {
    let timer = null;

    if (!isShowAnswer && history.total_time) {
      timer = setInterval(() => {
        if (timeRef.current <= 0) {
          clearInterval(timer);
          onUpdateScore();
          setLoading(true);
          setTimeout(() => {
            setLoading(false);
            setTimeout(() => {
              setTimeup(true);
            }, 500);
          }, 1000);
        } else {
          onChangeTime();
        }
      }, 1000);
    }

    return () => clearInterval(timer);
  }, [isShowAnswer, history.total_time]);

  useEffect(() => {
    fetchQuestionList();
  }, []);

  const setSelectedAnswer = (questionId, selectedOption) => {
  };

  function fetchQuestionList() {
    const questionTime = profile?.time_per_question
      ? profile?.time_per_question
      : community?.total_time_per_question ?? 90;

    if (practiceTest?.is_custom_test) {
      const result = GET_CUSTOM_TEST_DETAILS(
        questionsList,
        questionTime,
        practiceTest,
        profile,
        questionScrore
      );

      initalizePracticeTest(result);
    } else if (practiceTest?.is_retake_test) {
      const result = GET_RETAKE_TEST_DETAILS(practiceTest);
      initalizePracticeTest(result);
    } else {
      const result = GET_PRACTICE_TEST_DETAILS(
        questionsList,
        questionTime,
        practiceTest,
        numberOfQuestion
      );
      initalizePracticeTest(result);
    }
  }
  

  return (
    <div className="m-6" style={{ backgroundColor: currentTheme === 'light' ? theme?.background?.light : "#000000" }}>
      {/* Header */}
      <div className="flex items-center justify-between mb-6">
        <div className="flex items-center">
          <button
            className="rounded-lg border-2 p-2 mr-4 flex items-center justify-center"
            style={{ borderColor: currentTheme === "light" ? theme?.border_color?.light : theme?.border_color?.dark }}
            onClick={() => setTestExitPopup(true)}
          >
            <BackArrowIcon
              color={currentTheme === "light" ? theme?.text?.light : theme?.text?.dark}
            />
          </button>
          <h1 
            className="text-2xl font-semibold"
            style={{ color: getTextColor() }}
          >
            {`${history?.test_name ?? state?.test_name} (${history?.test_questions_meta_data?.length || 0})`}
          </h1>
        </div>
        
        {time != "" && !isShowAnswer && (
          <div 
            className="flex items-center gap-2 rounded-lg py-2 px-4"
            style={{ 
              backgroundColor:  getIconBg(),
              color: getTextColor(),
            }}
          >
            <FontAwesomeIcon icon={faClock} className="text-lg" />
            <span className="font-medium">{time}</span>
          </div>
        )}
      </div>

      {/* Question Navigation */}
      {/* <div className="flex items-center justify-between mb-4">
        <div 
          className="flex items-center bg-gray-100 dark:bg-gray-700 px-4 py-2 rounded-lg"
          style={{ 
            backgroundColor:  currentTheme == 'light' ? getNavBackground() : getIconBg(),
            color: currentTheme == 'light' ? getIconBg() : getTextColor(),
          }}
        >
          <FontAwesomeIcon icon={faQuestionCircle} className="mr-2" />
          <span className="font-bold">
            {`Question ${currentIndex + 1}`}
          </span>
          <span className="text-sm ml-1 text-black dark:text-white">
            / {history?.test_questions_meta_data?.length || 0}
          </span>
        </div>
      </div> */}

      {/* Question Card */}
      {currentItem && (
        <motion.div
          className="bg-white dark:bg-gray-800 rounded-xl overflow-hidden shadow-sm mb-6"
          whileHover="hover"
          variants={cardVariants}
        >
          <div style={getCardBackground(getIconBg())}>
            <div className="p-6">
              {/* Question Content */}
              <div className="mb-6">
                <HTMLContent
                  htmlContent={currentItem?.question?.question}
                  className="prose dark:prose-invert max-w-none"
                  style={{ color: getTextColor() }}
                />
              </div>

              {/* Answer Options */}
              <div className="grid gap-3 grid-cols-1 sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-2 items-stretch">
                {currentItem?.choices?.map((options, index) => {
                  const isSelected = selectedIndex
                    ? selectedIndex.selected == OPTIONS[index]
                    : false;

                  return (
                    <QuestionOptions
                      key={index + JSON.stringify(options)}
                      testName="test"
                      index={index}
                      item={options}
                      isShowAnswer={isShowAnswer}
                      correct={currentItem.question.correct_answer}
                      selected={
                        history?.test_questions_meta_data[currentIndex]
                          ?.selected_choice
                      }
                      isSubmit={(isSubmitAnswer?.[currentIndex] ?? false)}
                      onPress={() => {
                        const selected = OPTIONS[index];
                        const correct = currentItem?.question?.correct_answer;
                        const item =
                          history?.test_questions_meta_data[currentIndex];
                        if (Array.isArray(correct)) {
                          const previousSelectedOptions = history?.test_questions_meta_data?.[currentIndex]?.selected_choice == 'X' ? [] : (history?.test_questions_meta_data?.[currentIndex]?.selected_choice ?? [])
                          if (previousSelectedOptions.includes(selected)) {
                            let selectedOptions = [...previousSelectedOptions];
                            selectedOptions = selectedOptions.filter(
                              (e) => e != selected
                            );
                            item.selected_choice = selectedOptions;
                          } else {
                            const selectedOptions = [
                              ...previousSelectedOptions,
                            ];
                            selectedOptions.push(selected);
                            item.selected_choice = selectedOptions;
                          }
                          let isCorrect = true;
                          if (correct?.length == item?.selected_choice?.length) {
                            correct.forEach(element => {
                              if (!item?.selected_choice?.includes(element)) {
                                isCorrect = false
                              }
                            });
                          }
                          else {
                            isCorrect = false
                          }

                          if (selected.length > 0) {
                            item.response = isCorrect
                              ? STRING.correct_tag
                              : STRING.incorrect_tag;
                          } else {
                            item.response = STRING.unanswered_tag;
                          }
                          onSubmitQuestion(currentIndex, item);
                          setSelectedIndex({ selected: item.selected_choice, is_from_older: false });
                        } else {
                          item.selected_choice = selected ?? "X";
                          if (selected != "X" && selected != null) {
                            item.response =
                              correct == selected
                                ? STRING.correct_tag
                                : STRING.incorrect_tag;
                          } else {
                            item.response = STRING.unanswered_tag;
                          }
                          if (!isShowAnswer) {
                            onSubmitQuestion(currentIndex, item);
                            setSelectedIndex({
                              selected: selected,
                              is_from_older: false,
                            });
                          } else {
                            onSubmitQuestion(currentIndex, item);
                            setSelectedIndex({ selected: selected, is_from_older: false });

                            const submitted = { ...isSubmitAnswer }
                            submitted[currentIndex] = true
                            setSubmitAnswer(submitted)
                          }
                        }
                      }}
                    />
                  );
                })}
              </div>

              {/* Submit Button for Multi-select */}
              {isShowAnswer && 
               (isSubmitAnswer?.[currentIndex] ?? false) == false && 
               Array.isArray(currentItem?.question?.correct_answer) && 
               selectedIndex && 
               selectedIndex?.selected != '' && 
               selectedIndex?.selected != 'X' && 
               selectedIndex?.selected?.length > 0 && (
                <div className="flex justify-center mt-8">
                  <motion.button
                    variants={buttonVariants}
                    whileHover="hover"
                    whileTap="tap"
                    className="flex items-center px-6 py-3 rounded-lg text-white font-medium"
                    style={{ backgroundColor: getIconBg() }}
                    onClick={() => {
                      const submitted = { ...isSubmitAnswer };
                      submitted[currentIndex] = true;
                      setSubmitAnswer(submitted);
                    }}
                  >
                    <FontAwesomeIcon icon={faCheckDouble} className="mr-2" />
                    Submit Answer
                  </motion.button>
                </div>
              )}

              {/* Answer and Explanation */}
              {isShowAnswer && 
               (isSubmitAnswer?.[currentIndex] ?? false) && 
               selectedIndex && 
               selectedIndex.selected != 'X' && (
                <div className="mt-8 pt-6 border-t" style={{ borderColor: 'rgba(0,0,0,0.1)' }}>
                  <AnswerMessage
                    correct_answer={currentItem?.question?.correct_answer}
                    selected_answer={selectedIndex.selected}
                  />
                  <ExplanationComponent
                    explanation={currentItem.question?.explanation ?? ""}
                    topic={topic}
                    sub_domain={
                      currentItem?.question?.sub_domain
                        ? currentItem?.question?.sub_domain
                        : ""
                    }
                  />
                </div>
              )}
            </div>
          </div>
        </motion.div>
      )}

      {/* Navigation Controls */}
      <NavBar
        theme={theme}
        currentTheme={currentTheme}
        onNext={onNext}
        onPrevious={onPrevious}
        iconBg={getIconBg()}
        currentIndex={currentIndex}
        dataSet={history?.test_questions_meta_data?.length ?? 0}
        navTitle="Question"
        showEnd={true}
        onEndTest={onEndTest}
      />


      {/* Dialogs */}
      <AnimatePresence>
        {isTestEndPopup && (
          <InfoDialog
            isOpen={isTestEndPopup}
            title={STRINGS.test_end_warning}
            testName="test"
            description="You still have time left to complete the test. If you choose to end it now, your score will be calculated and you'll be redirected to the test performance page. <br>Click 'Cancel' to continue the test or 'Yes' to end it."
            actions={[
              {
                label: "Cancel",
                className: 'bg-gray-500 dark:bg-gray-700 text-white hover:bg-gray-600 dark:hover:bg-gray-800',
                onClick: () => {
                  setTestEndPopup(false);
                },
              },
              {
                label: "Yes",
                className: 'bg-lz-blue text-white hover:bg-lz-orange',
                onClick: () => {
                  setTestEndPopup(false);
                  onSaveTestHistory(false);
                },
              },
            ]}
          />
        )}

        {isTestExitPopup && (
          <InfoDialog
            isOpen={isTestExitPopup}
            title={STRINGS.test_exit_warning}
            description="Are you sure you want to exit the test? Your progress will not be saved."
            actions={[
              {
                label: "Cancel",
                className: 'bg-gray-500 dark:bg-gray-700 text-white hover:bg-gray-600 dark:hover:bg-gray-800',
                onClick: () => {
                  setTestExitPopup(false);
                },
              },
              {
                label: "Yes",
                className: 'bg-lz-blue text-white hover:bg-lz-orange',
                onClick: () => {
                  navigate(-1, { state: { isFromBack: true } });
                  setTestExitPopup(false);
                },
              },
            ]}
          />
        )}

        {isTimeup && (
          <InfoDialog
            isOpen={isTimeup}
            title={STRINGS.time_up_message}
            description=" "
            actions={[
              {
                label: "Show Test Performance",
                className: 'bg-lz-blue text-white hover:bg-lz-orange',
                onClick: () => {
                  setTimeup(false);
                  onSaveTestHistory(false);
                },
              },
            ]}
          />
        )}
      </AnimatePresence>
    </div>
  );
};

export default Test;